/* unplugin-vue-components disabled */import script from "./AddressList.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressList.vue?vue&type=script&setup=true&lang=js"

import "./AddressList.vue?vue&type=style&index=0&id=3184aa2e&lang=scss"

const __exports__ = script;

export default __exports__